export function ExtractTikz(tikz) {
  // Pré-processamento extração de partes significativas do TIKZ
  const regexPreproc = /\\begin{tikzpicture}(.*?)\\end{tikzpicture}/s;
  if (regexPreproc.exec(tikz)) {
    tikz = regexPreproc.exec(tikz)[1];
    if (!tikz.split("}]") === null) {
      tikz = tikz.split("}]")[1];
    }
    return tikz;
  } else {
    console.log("ERRO");
  }
}
